import { createTheme } from '@mui/material';

const myTheme = createTheme({
	palette: {
		primary: {
			main: '#0C8040', // By default color on the button
			light: '0 10px 20px rgba(250, 250, 250, 0.19), 0 6px 6px rgba(251, 251, 251, 0.23);',
			dark: '#228a51', // when we hover on the button
			contrastText: '#fff', // text color on the button
		},
		secondary: {
			main: '#1976d2',
			light: '#42a5f5',
			dark: '#1565c0',
			contrastText: '#fff',
		},
		error: {
			main: '#e40a0a',
			light: '#42a5f5',
			dark: '#1565c0',
			contrastText: '#fff',
		},
		warning: {
			main: '#1976d2',
			light: '#42a5f5',
			dark: '#1565c0',
			contrastText: '#fff',
		},
		info: {
			main: '#000', // black
			light: '#42a5f5',
			dark: '#0C8040',
			contrastText: '#000',
		},
		success: {
			main: '#0C8040',
			light: '#42a5f5',
			dark: '#228a51',
			contrastText: '#fff',
		},

		action: {
			active: 'rgb(30, 147, 97)',
			hover: '#228a51',
			hoverOpacity: 0.04,
			selected: 'rgb(193, 0, 0)',
			selectedOpacity: 0.08,
			disabled: 'rgba(0, 0, 0, 0.26)',
			disabledBackground: 'rgba(0, 0, 0, 0.12)',
			disabledOpacity: 0.38,
			focus: 'rgba(0, 0, 0, 0.12)',
			focusOpacity: 0.12,
			activatedOpacity: 0.12,
		},
		text: {
			primary: '#000',
			secondary: '#999999',
			disabled: '#4D4D4D',
		},
	},
	typography: {
		fontFamily: `'Poppins', 'Helvetica', 'Arial', sans-serif`,
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none', // Override to prevent all caps text
				},
			},
		},
		MuiIconButton: {
			styleOverrides: {
				root: {
					'&:hover': {
						color: '#0C8040', // Set content color to white on hover
						fill: '#0C8040', // Set fill color to white on hover
					},
				},
			},
		},
		MuiSvgIcon: {
			styleOverrides: {
				root: {
					'&:hover': {
						// Customize as needed
					},
				},
			},
		},
		MuiListItemButton: {
			styleOverrides: {
				root: {
					'&:hover': {
						'& .MuiSvgIcon-root': {
							// Customize as needed
						},
					},
				},
			},
		},
	},
});

export default myTheme;
